<template>
    <div :class="{'layout-centered': centered}">
        <div class="container-fluid mt-5 mb-5">
            <transition name="fade" mode="out-in">
                <router-view />
            </transition>
        </div>
    </div>
</template>



<script>
    export default {
        name: 'LayoutBasic',
        props: {
            centered: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>



<style lang="scss" scoped>
    .container-fluid {
        max-width: map-get($grid-breakpoints, 'xl');
    }
    .layout-centered {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: auto;
        min-height: 100vh;
    }
</style>
